import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { menuCategories } from '../data/menu';
export function MenuSection() {
  const [active, setActive] = useState(menuCategories[0].id);
  const category = menuCategories.find(c => c.id === active) ?? menuCategories[0];
  return <section id="carte" aria-labelledby="carte-title" className="w-full bg-cream-100 py-24 text-forest-950 lg:py-32" data-id="element-25" data-mp="1r0ff6pkx5vkh">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 lg:grid-cols-12 lg:px-10" data-id="element-26" data-mp="13abb6h3tjtsy">
        <div className="lg:col-span-4" data-id="element-27" data-mp="ybrnoc9ku9yh">
          <h2 id="carte-title" className="font-serif text-6xl font-light leading-none md:text-7xl" data-id="element-28" data-mp="y8m1p5w8vo6z">
            La carte
          </h2>
          <p className="font-script mt-2 text-5xl text-brick" data-id="element-29" data-mp="17av75hcnordi">de saison</p>
          <p className="mt-6 max-w-xs leading-relaxed text-forest-800/75" data-id="element-30" data-mp="jlstslp21kot">
            Produits frais, cuisinés sur place. Ardoise du jour le midi en semaine — demandez-la à table.
          </p>

          <div role="tablist" aria-label="Catégories de la carte" className="mt-10 flex flex-wrap gap-2 lg:flex-col lg:items-start" data-id="element-31" data-mp="fie8pgm9ee4i">
            {menuCategories.map(c => {
            const selected = c.id === active;
            return <button key={c.id} role="tab" type="button" id={`tab-${c.id}`} aria-selected={selected} aria-controls={`panel-${c.id}`} onClick={() => setActive(c.id)} className={`whitespace-nowrap rounded-full px-5 py-2 text-sm font-medium transition-colors duration-150 lg:px-0 lg:py-1 lg:font-serif lg:text-3xl lg:font-normal lg:rounded-none ${selected ? 'bg-forest-900 text-cream-50 lg:bg-transparent lg:text-forest-950' : 'bg-forest-950/5 text-forest-800/70 hover:text-forest-950 lg:bg-transparent lg:text-forest-800/40'}`} data-id="element-32" data-mp="47zxd81dh0m7">
                  {c.label}
                </button>;
          })}
          </div>
        </div>

        <div className="lg:col-span-8 lg:pt-4" data-id="element-33" data-mp="2sza7z5zw0xty">
          <AnimatePresence mode="wait" data-id="element-34" data-mp="2t0lc56x8w7ll">
            <motion.ul key={category.id} id={`panel-${category.id}`} role="tabpanel" aria-labelledby={`tab-${category.id}`} initial={{
            opacity: 0,
            y: 8
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -8
          }} transition={{
            duration: 0.18,
            ease: [0.23, 1, 0.32, 1]
          }} className="divide-y divide-forest-950/15 border-y border-forest-950/15" data-id="element-35" data-mp="36yrzht4kip70">
              {category.items.map(item => <li key={item.name} className="flex flex-col gap-1 py-6 sm:flex-row sm:items-baseline sm:gap-6" data-id="element-36" data-mp="2j74ka8go52kk">
                  <div className="flex-1" data-id="element-37" data-mp="1vha4bi11yxw3">
                    <p className="font-serif text-2xl md:text-3xl" data-id="element-38" data-mp="1ri1fmrkvdq7e">{item.name}</p>
                    <p className="mt-1 text-sm text-forest-800/65" data-id="element-39" data-mp="1hdl0k0f7sd4n">{item.description}</p>
                  </div>
                  <p className="whitespace-nowrap font-serif text-2xl text-brick" data-id="element-40" data-mp="1m4t96u8pzugr">{item.price}</p>
                </li>)}
            </motion.ul>
          </AnimatePresence>
          <p className="mt-6 text-xs text-forest-800/60" data-id="element-41" data-mp="1cehtybjl5yuk">
            Prix nets, service compris. Carte susceptible d’évoluer selon les arrivages.
          </p>
        </div>
      </div>
    </section>;
}